import CodeSystemPage from "components/CodeSystemPage";
import { KISSearchWithFilterTestVersion } from "components/search/buckets/KISSearchWithFilter";
import { CodeSystem } from "context/elasticsearch/types";
import { MainPage } from "pages";
import GeneralSearchTestResults from "pages/GeneralSearchTestResults";
import {
  AnatomiskPage,
  NLKPage,
  ProvematerialePage,
  TekstligeResultatverdierPage,
  UndersokelsesmetodePage
} from "pages/Lab";
import { AdmPage, SnomedCTPage } from "pages/Other";
import PageNotFound from "pages/PageNotFound";
import { Route, Routes } from "react-router-dom";
import { paths } from "utils";

const codeValue = "codeValue";
const view = "view";
const environment = import.meta.env.VITE_ENVIRONMENT;

const Router = () => {
  return (
    <Routes>
      <Route path={paths.main} index element={<MainPage />} />

      {/* Kliniske kodeverk - Generic route for KIS code systems */}
      <Route
        path={`${paths.icd10}/:${view}?/:${codeValue}?`}
        element={<CodeSystemPage codeSystem={CodeSystem.Icd10} />}
      />
      <Route
        path={`${paths.icpc2}/:${view}?/:${codeValue}?`}
        element={<CodeSystemPage codeSystem={CodeSystem.Icpc2} />}
      />
      <Route
        path={`${paths.nkpk}/:${view}?/:${codeValue}?`}
        element={<CodeSystemPage codeSystem={CodeSystem.Nkpk} />}
      />
      <Route
        path={`${paths.phbu}/:${view}?/:${codeValue}?`}
        element={<CodeSystemPage codeSystem={CodeSystem.Phbu} />}
      />
      <Route
        path={`${paths.norpat}/:${view}?/:${codeValue}?`}
        element={<CodeSystemPage codeSystem={CodeSystem.Norpat} />}
      />
      {environment === "dev" && (
        <>
          <Route
            path={`${paths.icd10}/testside/`}
            element={
              <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icd10} />
            }
          >
            <Route
              path={`:${view}`}
              element={
                <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icd10} />
              }
            />
            <Route
              path={`:${view}/:${codeValue}`}
              element={
                <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icd10} />
              }
            />
          </Route>
          <Route
            path={`${paths.adm}/testside/`}
            element={
              <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Adm} />
            }
          >
            <Route
              path={`:${view}`}
              element={
                <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Adm} />
              }
            />
            <Route
              path={`:${view}/:${codeValue}`}
              element={
                <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Adm} />
              }
            />
          </Route>
          <Route
            path={`${paths.icpc2}/testside/`}
            element={
              <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icpc2} />
            }
          >
            <Route
              path={`:${view}`}
              element={
                <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icpc2} />
              }
            />
            <Route
              path={`:${view}/:${codeValue}`}
              element={
                <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icpc2} />
              }
            />
          </Route>
          <Route
            path={`${paths.norpat}/testside/`}
            element={
              <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Norpat} />
            }
          >
            <Route
              path={`:${view}`}
              element={
                <KISSearchWithFilterTestVersion
                  codeSystem={CodeSystem.Norpat}
                />
              }
            />
            <Route
              path={`:${view}/:${codeValue}`}
              element={
                <KISSearchWithFilterTestVersion
                  codeSystem={CodeSystem.Norpat}
                />
              }
            />
          </Route>
          <Route
            path={`${paths.nkpk}/testside/`}
            element={
              <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Nkpk} />
            }
          >
            <Route
              path={`:${view}`}
              element={
                <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Nkpk} />
              }
            />
            <Route
              path={`:${view}/:${codeValue}`}
              element={
                <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Nkpk} />
              }
            />
          </Route>
          <Route
            path={`${paths.phbu}/testside/`}
            element={
              <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Phbu} />
            }
          >
            <Route
              path={`:${view}`}
              element={
                <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Phbu} />
              }
            />
            <Route
              path={`:${view}/:${codeValue}`}
              element={
                <KISSearchWithFilterTestVersion codeSystem={CodeSystem.Phbu} />
              }
            />
          </Route>
        </>
      )}

      {/* Lab kodeverk */}
      <Route path={paths.nlk} element={<NLKPage />}>
        <Route path={`:${codeValue}`} element={<NLKPage />} />
      </Route>
      <Route path={paths.anatomisk} element={<AnatomiskPage />}>
        <Route path={`:${codeValue}`} element={<AnatomiskPage />} />
      </Route>
      <Route
        path={paths.tekstligeresultatverdier}
        element={<TekstligeResultatverdierPage />}
      >
        <Route
          path={`:${codeValue}`}
          element={<TekstligeResultatverdierPage />}
        />
      </Route>
      <Route
        path={paths.undersokelsesmetode}
        element={<UndersokelsesmetodePage />}
      >
        <Route path={`:${codeValue}`} element={<UndersokelsesmetodePage />} />
      </Route>
      <Route path={paths.provemateriale} element={<ProvematerialePage />}>
        <Route path={`:${codeValue}`} element={<ProvematerialePage />} />
      </Route>

      {/* Annet */}
      <Route path={paths.snomed} element={<SnomedCTPage />}>
        <Route path={`:${view}`} element={<SnomedCTPage />} />
        <Route path={`:${view}/:${codeValue}`} element={<SnomedCTPage />} />
      </Route>

      <Route path={`${paths.adm}/`} element={<AdmPage />}>
        <Route path={`:${view}`} element={<AdmPage />} />
        <Route path={`:${view}/:${codeValue}`} element={<AdmPage />} />
      </Route>
      <Route
        path={`soketestforsynonymer/`}
        element={<GeneralSearchTestResults />}
      >
        <Route path={`:${codeValue}`} element={<GeneralSearchTestResults />} />
      </Route>

      {/* Catch-all route must be last */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default Router;
